<template>
  <div id="back">
    <div
      style="display: flex; justify-content: space-between; padding: 44px 27px"
    >
      <a style="color: #fcda29" @click="openLogin" v-if="!login_status"
        >点击此处,先登陆</a
      >
      <span v-if="login_status"
        ><a style="color: #000; margin-right: 8px; font-size: 12px"
          >账号：{{ user_name }}</a
        >
        <a style="color: #fcda29" @click="switchUsers">切换账号</a></span
      >
      <a style="color: #fcda29" @click="openRecord">中奖记录</a>
    </div>
    <div id="title">{{ name }}</div>
    <!--    滚动条-->
    <div id="scroll">
      <ul id="con1" ref="con1" :class="{ anim: animate == true }">
        <li v-for="(item, index) in items" :key="index">{{ item.name }}</li>
      </ul>
    </div>
    <!--    抽奖原盘-->
    <div id="lottery">
      <!--      距离活动结束-->
      <div id="end_time">
        距离活动结束还有：{{ day }}天{{ hour }}时{{ min }}分{{ second }}秒
      </div>
      <!-- <div id="circle0" ref="circle"> -->
      <big-wheel
        ref="bigWheel"
        :prizeList="prizeList"
        :prizeBgColors="prizeBgColors"
        @over="over"
        id="big-wheel"
      >
        <template v-slot:item="{ item }">
          <div class="prize-name">{{ item.txt }}</div>
          <img class="prize-img" :src="item.img" />
        </template>
      </big-wheel>
      <div id="choose_gift" @click="lottery"></div>
    </div>
    <!--    活动规则-->
    <div>
      <h1 id="rules">活动规则</h1>
      <div id="rules_content">
        <p>{{ rules }}</p>
      </div>
    </div>
    <!--   下载游戏-->
    <div
      style="text-align: center"
      v-if="this.game_download_url"
      @click="downLoad"
      id="down"
    >
      <img
        src="//static.hzwxbz3.cn/Lianyun/font_end/wxhd/voucher/downLoad.png"
        alt=""
      />
    </div>
    <!--登陆-->
    <Login
      v-if="show"
      @close="closeLogin"
      ref="login"
      @freshTemp="openLogin"
      style="z-index: 9"
      @submit="login"
    ></Login>
    <!--抽奖记录-->
    <Record v-if="recordShow" @close="recordShow = false" ref="Record"></Record>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import BigWheel from '@/components/BigWheel';

import { Toast } from 'vant';
import Login from './Login.vue';
import Record from './record';
import {
  usersLogin,
  usersInitLogin,
  giftDetail,
  drawResults,
  drawRecord,
  eventTrackApi,
} from '../../apis/voucher';

export default {
  name: 'index',
  data() {
    return {
      name: '',
      prizeBgColors: ['#ffea99', '#ffffff'],
      prizeList: [],
      recordShow: false,
      show: false,
      animate: false,
      items: [],
      gift_items: [], // 礼包列表
      appkey: this.GetUrlString('appkey'),
      credential: '', // 获取凭证
      user_name: '',
      login_status: false, // 登录态
      game_download_url: '',
      user_id: '',
      token: '',
      end_time: '',
      day: '',
      hour: '',
      min: '',
      second: '',
      circleNum: '', // 圈数
      flag: false, // 防止多次点击
      msg: '', // 中奖信息
      rules: '',
    };
  },
  components: {
    Login,
    Record,
    BigWheel,
  },
  created() {

    if (localStorage.getItem('userMsg')) {
      (this.user_id = JSON.parse(localStorage.getItem('userMsg')).user_id),
        (this.user_name = JSON.parse(
          localStorage.getItem('userMsg')
        ).user_name);
    }
    this.initLogin();
    localStorage.getItem('Token')
      ? (this.login_status = true)
      : (this.login_status = false);
    this.giftDetailList(this.appkey);
  },
  methods: {
    // 埋点上报
    report(type) {
      eventTrackApi({
        appkey: this.appkey,
        event: type + this.appkey,
        device_id: '',
        user_id: this.user_id,
      });
    },
    // 展示时间
    countDown(number) {
      // 传入时间戳
      let timeStamp = number - Math.round(new Date().getTime() / 1000); // 传入时间戳减去当前时间戳。 除1000是为了消除毫秒
      var timer = setInterval(() => {
        // 设置定时器 一秒更新一次数据
        if (timeStamp <= 0) {
          // 如果到0了以后清除定时器
          this.day = '00';
          this.hour = '00';
          this.second = '00';
          clearInterval(timer);
        }
        timeStamp -= 1;
        // 计算 天 时 分 秒
        const tempDay = Math.floor(timeStamp / (60 * 60 * 24));
        const tempHour = Math.floor(timeStamp / (60 * 60)) - tempDay * 24;
        const tempMin =
          Math.floor(timeStamp / 60) - tempDay * 24 * 60 - tempHour * 60;
        const tempSecond =
          timeStamp -
          tempDay * 24 * 60 * 60 -
          tempHour * 60 * 60 -
          tempMin * 60;
        // 为了倒计时 个数和双数不影响宽度变化 做数据处理
        this.day = String(tempDay).length === 1 ? '0' + tempDay : tempDay;
        this.hour = String(tempHour).length === 1 ? '0' + tempHour : tempHour;
        this.min = String(tempMin).length === 1 ? '0' + tempMin : tempMin;
        this.second =
          String(tempSecond).length === 1 ? '0' + tempSecond : tempSecond;
      }, 1000);
    },
    // 获取礼包列表
    giftDetailList(data) {
      giftDetail({ appkey: data }).then((res) => {
        this.gift_items = res.content.options;
        res.content.options.map((item) => {
          this.prizeList.push({
            txt: item.name,
            img: item.icon_url,
          });
        });
        this.game_download_url = res.content.game_download_url;
        this.end_time = res.content.end_time;
        this.rules = res.content.rule;
        this.name = res.content.name;
        // 弹幕
        let array = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',];
        for (let a = 0; a < 10; a++) {
          let str = '';
          // 随机抽取礼物
          let n = Math.floor(Math.random() * this.gift_items.length + 1) - 1;
          for (let i = 0; i < 8; i++) {
            str += array[Math.round(Math.random() * (array.length - 1))];
          }
          this.items.push({
            name: `恭喜玩家${str}获得${this.gift_items[n].name}`,
          });
        }
        this.countDown(res.content.end_time);
        this.$refs.bigWheel.init();
        setInterval(this.scroll, 1000);
      });
    },
    // 开始旋转
    lottery() {
      // 埋点上报
      this.report('VOUCHER_H5_LOTTERY_');
      if (this.flag) {
        Toast('每个玩家账号仅可参与一次活动');
        return;
      }
      // 判断是否登陆
      if (localStorage.getItem('Token')) {
        console.log(localStorage.getItem('userMsg'));
        drawResults({
          user_id: JSON.parse(localStorage.getItem('userMsg')).user_id,
          appkey: this.appkey,
          activity_token: localStorage.getItem('Token'),
        }).then((res) => {
          this.msg = res;
          // 礼包类型为代金券
          if (res.content.type == 1) {
            this.gift_items.map((item, index) => {
              // 匹配转的圈数
              if (res.content.voucher_dispatch_id == item.voucher_dispatch_id) {
                this.circleNum = index;
              }
            });
          } else {
            this.gift_items.map((item, index) => {
              // 匹配转的圈数
              if (res.content.gift_id == item.gift_id) {
                this.circleNum = index;
              }
            });
          }
          // 转动转盘
          this.$refs.bigWheel.rotate(this.circleNum);
          //  防止多次抽奖
          this.flag = true;
        });
      } else {
        this.openLogin();
      }
    },
    // 登陆
    openLogin() {
      this.show = true;
      this.$nextTick(() => {
        this.$refs.login.title = '账号登录';
      });
    },
    // 切换账号
    switchUsers() {
      this.show = true;
      this.$nextTick(() => {
        this.$refs.login.title = '账号切换';
      });
    },
    // 打开记录
    openRecord() {
      if (localStorage.getItem('Token')) {
        this.recordShow = true;
        drawRecord({
          user_id: JSON.parse(localStorage.getItem('userMsg')).user_id,
          appkey: +this.appkey,
          activity_token: localStorage.getItem('Token'),
        }).then((res) => {
          console.log(res);
          (this.$refs.Record.voucherContent = res.content.receive_notice),
            //     this.getCaption(
            //     res.content.receive_notice,
            //     res.content.type
            // );
            (this.$refs.Record.gift_code = res.content.gift_code);
          this.$refs.Record.type = res.content.type;
          // this.flag = false
        });
      } else {
        this.openLogin();
      }
    },
    // 账号密码登陆
    login(userInfo) {
      usersLogin({
        user_name: userInfo.username,
        password: CryptoJS.MD5(
          userInfo.password + CryptoJS.MD5(userInfo.password)
        ).toString(),
        appkey: this.appkey,
      })
        .then((res) => {
          // this.appkey = res.content.appkey;
          this.user_name = res.content.user_name;
          this.user_id = res.content.user_id;
          this.token = res.content.activity_token;
          this.login_status = true;
          this.flag = false;
          // 用户信息储存
          localStorage.setItem('Token', res.content.activity_token);
          localStorage.setItem('userMsg', JSON.stringify(res.content));
          // 埋点上报
          this.report('VOUCHER_H5_USER_BIND_');
        })
        .catch((err) => {
          this.show = true;
        });
    },
    // 根据凭证登陆
    initLogin() {
      this.appkey = this.GetUrlString('appkey');
      this.credential = this.GetUrlString('credential');
      if (this.credential) {
        usersInitLogin({
          appkey: this.appkey,
          credential: this.credential,
        }).then((res) => {
          this.user_name = res.content.user_name;
          this.user_id = res.content.user_id;
          this.token = res.content.activity_token;
          this.login_status = true;
          this.flag = false;
          // 埋点上报
          this.report('VOUCHER_H5_USER_BIND_');
          // 用户信息储存
          localStorage.setItem('Token', res.content.activity_token);
          localStorage.setItem('userMsg', JSON.stringify(res.content));
        });
      } else {
        console.log(456);
      }
    },
    // 获取平台url后的拼接字符串参数方法
    GetUrlString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    // 弹幕滚动
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        this.items.push(this.items[0]); // 将数组的第一个元素添加到数组的
        this.items.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 500);
    },
    //  字符串截取
    getCaption(str, type) {
      let index = '';
      if (type == 1) {
        index = str.lastIndexOf('中');
      } else {
        index = str.lastIndexOf('户');
      }
      str = str.substr(index + 1, str.length);
      return str;
    },
    closeLogin() {
      this.show = false;
    },
    over() {
      this.openRecord();
    },
    downLoad() {
      // 埋点上报
      this.report('VOUCHER_H5_DOWNLOAD_');
      window.open(this.game_download_url, '_blank');
    },
  },
};
</script>

<style scoped>
#back {
  background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/voucher/background.jpg')
    no-repeat;
  background-size: 375px 829px;
  width: 100%;
  height: 829px;
}

#scroll {
  width: 289px;
  height: 73px;
  margin-top: 30px;
  margin-left: 45px;
  overflow: hidden;
  text-align: center;
}

#end_time {
  width: 279px;
  height: 30px;
  margin-left: 30px;
  border-radius: 80px;
  position: absolute;
  z-index: 8;
  margin-top: 10px;
  line-height: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  font-size: 14.58px;
  text-align: center;
  color: #ffffff;
  background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/voucher/roundRectangle.png');
  background-size: 279px 30px;
}

#lottery {
  width: 360px;
  height: 360px;
  /* margin-left: 3px; */
  margin-top: 20px;
  background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/voucher/voucherBg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  text-align: center;
  /* padding-top: 30px; */
}

#choose_gift {
  width: 145px;
  height: 148px;
  background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/voucher/voucherBtn.png')
    no-repeat;
  background-size: 135px 140px;
  top: 385px;
  left:115px;
  display: flex;
  position: absolute;
}

#rules {
  width: 90px;
  height: 21.53px;
  font-size: 21.88px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  margin-left: 23px;
  color: #ffffff;
}

#rules_content {
  width: 327.08px;
  /* height: 121.88px; */
  font-size: 12.5px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  margin-left: 23px;
  color: #ffffff;
}

#rules_content p {
  margin: 5px;
  text-align: left;
  line-height: 20px
}

.anim {
  transition: all 0.5s;
  margin-top: -45px;
}

#con1 li {
  list-style: none;
  line-height: 30px;
  height: 30px;
  margin: 15px 0;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
  border-radius: 50%;
  border-radius: 30px;
}

.prize-img {
  position: absolute;
  top: 0.58rem;
  left: 50%;
  transform: translateX(-50%);
  width: 35px;
  height: 35px;
  z-index: 999;
}

.prize-name {
  position: absolute;
  left: 0.13rem;
  right: 0.13rem;
  top: 0.2rem;
  font-size: 0.14rem;
  text-align: center;
  z-index: 999;

}

#big-wheel {
  width: 290px;
  height: 290px;
  margin-top: 35px;
}

#title {
  text-align: center;
  font-weight: 700;
  color: #fff;
  font-size: 50px;
}
#down img{
  width: 203px;
  height: 55px;
  position: fixed;
  left:20%;
  bottom:30px
}
</style>
